<template>
    <div class="singleSet">
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <!-- 标题 -->
                <span class="font-sz24">{{ $t('进度状态设置.进度状态设置') }}</span>
                <div class="head-text">
                    <el-button type="primary" @click="addSingle = true">{{ $t('common.添加') }}</el-button>
                </div>
            </div>
            <!-- 表格 -->
            <div class="rygl-table">
                <el-table align="center" class="margin-20 table width100" v-loading="loading" :data="dataList"
                    height="72vh">
                    <el-table-column align="center" type="selection" width="55"></el-table-column>
                    <el-table-column align="center" prop="order" :label="$t('进度状态设置.排序')"></el-table-column>
                    <el-table-column align="center" prop="name" :label="$t('进度状态设置.状态名称')"></el-table-column>
                    <el-table-column align="center" prop="color" :label="$t('进度状态设置.颜色')">
                        <template slot-scope="scope">
                            <el-color-picker @change="setProgressShowState(scope.row)"
                                v-model="scope.row.color"></el-color-picker>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" prop="time" :label="$t('进度状态设置.更新时间')"></el-table-column>
                    <el-table-column align="center" :label="$t('进度状态设置.操作')">
                        <template slot-scope="scope">
                            <el-button size="small" type="primary" @click="editor(scope.row)" plain>{{ $t('common.修改')
                                }}</el-button>
                            <el-button size="small" type="danger" @click="delProgressShowState(scope.row)" plain>{{
                                $t('common.删除') }}</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <el-dialog :close-on-click-modal="false" :title="$t('进度状态设置.设置进度状态')" :visible.sync="addSingle" width="30%">
                <el-form ref="form" :model="model" label-width="150px">
                    <el-form-item :label="$t('进度状态设置.状态名称')">
                        <el-input v-model="model.name"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('进度状态设置.排序')">
                        <el-input type="number" v-model.number="model.order"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('进度状态设置.颜色')">
                        <el-color-picker v-model="model.color"></el-color-picker>
                    </el-form-item>
                    <el-row>
                        <el-col :span="3" :offset="5">
                            <el-button type="primary" @click="setProgressShowState">{{ $t('common.确定') }}</el-button>
                        </el-col>
                        <el-col :span="3" :offset="5">
                            <el-button type="danger" @click="addSingle = false">{{ $t('common.取消') }}</el-button>
                        </el-col>
                    </el-row>
                </el-form>
            </el-dialog>
        </el-card>
    </div>
</template>

<script>
import { setProgressShowState, getProgressShowState, delProgressShowState } from "@/setAxios.js";
import dayjs from "dayjs";
export default {
    name: "singleSet",
    data() {
        return {
            loading: false,
            addSingle: false,
            dataList: [],
            model: {
                id: 0,
                name: "",
                order: 1,
                color: "",
                time: "",
                xid: localStorage.xid
            },
        };
    },
    methods: {
        // 添加/修改
        setProgressShowState(row) {
            if (row.name && row.color && row.order)
                this.model = row;
            this.loading = true;
            if (!this.model.name || !this.model.color || !this.model.order) {
                this.$message({
                    type: "error",
                    message: this.$t('common.请填写必填项'),
                });
                this.loading = false;
                return;
            }
            this.model.time = dayjs().format("YYYY-MM-DD HH:mm:ss");
            setProgressShowState(this.model).then((res) => {
                this.addSingle = false;
                if (res.Code) {
                    this.$message.success(this.$t('common.处理成功'))
                    this.getData();
                    this.loading = false;
                }
            });
        },
        //删除
        delProgressShowState(data) {
            this.loading = true;
            let params = {
                id: data.id
            }
            delProgressShowState(params).then((res) => {
                if (res.Code === 1) {
                    this.$message({
                        type: "success",
                        message: this.$t('common.处理成功')
                    });
                }
                this.getData();
                this.loading = false;
            });
        },

        // 编辑工单
        editor(row) {
            this.addSingle = true;
            this.model = row;
        },

        // 获取所有数据
        getData() {
            this.loading = true;
            let params = {
                xid: localStorage.xid
            };
            getProgressShowState({ params }).then((res) => {
                this.dataList = res.Data;
                this.loading = false;
            });
        },

    },
    created() {
        this.getData();
    },
};
</script>

<style lang="less" scoped>
/deep/ .el-dialog__body {
    padding-bottom: 20px;
}
</style>
<style scoped>
/* 新增 */
.font-sz24 {
    font-size: 24px;
}

.head-text {
    float: right;
    margin-top: -4px;
}

.width100 {
    width: 100%;
}

.mar-top20 {
    margin-top: 20px;
}
</style>
